import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import { setToken } from "../utils/auth";

const BASE_URL = process.env.REACT_APP_API_URL || "/api";

export default function LoginPage() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await axios.post(`${BASE_URL}/auth/login`, form);
      setToken(res.data.token);
      toast.success("Welcome to Makalu Admin");
      navigate("/");
    } catch {
      toast.error("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ background: "radial-gradient(ellipse at 50% 0%, rgba(200,150,12,0.07) 0%, #0a0a0a 60%)" }}
    >
      {/* Decorative top glow */}
      <div style={{ position: "fixed", top: 0, left: 0, right: 0, height: 3, background: "linear-gradient(90deg, transparent, #8A6000, #FFD700, #C8960C, #FFD700, #8A6000, transparent)" }} />

      <div className="w-full max-w-sm">

        {/* Logo block */}
        <div className="text-center mb-10">
          <div className="flex justify-center mb-4">
            <div style={{ padding: "14px", borderRadius: "50%", background: "rgba(200,150,12,0.07)", border: "1px solid rgba(200,150,12,0.25)" }}>
              <img src="/makalu-logo.svg" alt="Makalu" style={{ height: 64, width: "auto", display: "block" }} />
            </div>
          </div>
          <div style={{ fontSize: 12, color: "#C8960C", letterSpacing: "0.22em", fontWeight: 800 }}>MAKALU AGRO AND TRADE</div>
          <div style={{ fontSize: 9, color: "#5a4a30", letterSpacing: "0.18em", marginTop: 3 }}>SACRED HIMALAYAN RUDRAKSHA</div>
          <div style={{ height: 1, background: "linear-gradient(90deg, transparent, rgba(200,150,12,0.5), transparent)", margin: "14px auto", maxWidth: 180 }} />
          <div style={{ fontSize: 11, color: "#8A6000", letterSpacing: "0.16em", fontWeight: 600 }}>ADMIN PORTAL</div>
        </div>

        {/* Card */}
        <div
          className="rounded-2xl p-8"
          style={{
            background: "linear-gradient(160deg, #181818 0%, #111 100%)",
            border: "1px solid rgba(200,150,12,0.3)",
            boxShadow: "0 32px 64px rgba(0,0,0,0.6), 0 0 0 1px rgba(200,150,12,0.05)",
          }}
        >
          {/* Gold top accent */}
          <div style={{ height: 2, background: "linear-gradient(90deg, transparent, #C8960C, #FFD700, #C8960C, transparent)", borderRadius: 1, marginBottom: 28 }} />

          <form onSubmit={handleSubmit} className="space-y-5">
            {/* Email */}
            <div>
              <label style={{ display: "block", fontSize: 10, color: "#8A6000", letterSpacing: "0.15em", textTransform: "uppercase", fontWeight: 700, marginBottom: 8 }}>
                Email Address
              </label>
              <div style={{ position: "relative" }}>
                <svg style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", width: 16, height: 16, color: "#5a4a30" }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <input
                  type="email"
                  required
                  value={form.email}
                  onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
                  placeholder="admin@example.com"
                  style={{
                    width: "100%", paddingLeft: 38, paddingRight: 14, paddingTop: 11, paddingBottom: 11,
                    background: "rgba(255,255,255,0.03)", border: "1px solid rgba(200,150,12,0.25)",
                    borderRadius: 10, color: "#f5f0e8", fontSize: 14, outline: "none",
                    boxSizing: "border-box",
                  }}
                  onFocus={e => e.target.style.borderColor = "rgba(200,150,12,0.7)"}
                  onBlur={e => e.target.style.borderColor = "rgba(200,150,12,0.25)"}
                />
              </div>
            </div>

            {/* Password */}
            <div>
              <label style={{ display: "block", fontSize: 10, color: "#8A6000", letterSpacing: "0.15em", textTransform: "uppercase", fontWeight: 700, marginBottom: 8 }}>
                Password
              </label>
              <div style={{ position: "relative" }}>
                <svg style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", width: 16, height: 16, color: "#5a4a30" }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <input
                  type={showPass ? "text" : "password"}
                  required
                  value={form.password}
                  onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
                  placeholder="••••••••"
                  style={{
                    width: "100%", paddingLeft: 38, paddingRight: 42, paddingTop: 11, paddingBottom: 11,
                    background: "rgba(255,255,255,0.03)", border: "1px solid rgba(200,150,12,0.25)",
                    borderRadius: 10, color: "#f5f0e8", fontSize: 14, outline: "none",
                    boxSizing: "border-box",
                  }}
                  onFocus={e => e.target.style.borderColor = "rgba(200,150,12,0.7)"}
                  onBlur={e => e.target.style.borderColor = "rgba(200,150,12,0.25)"}
                />
                <button
                  type="button"
                  onClick={() => setShowPass(v => !v)}
                  style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "#5a4a30", padding: 0 }}
                >
                  {showPass ? (
                    <svg style={{ width: 16, height: 16 }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                    </svg>
                  ) : (
                    <svg style={{ width: 16, height: 16 }} fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  )}
                </button>
              </div>
            </div>

            {/* Submit */}
            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%", padding: "13px", marginTop: 4,
                background: loading ? "rgba(200,150,12,0.3)" : "linear-gradient(135deg, #8A6000, #C8960C, #FFD700, #C8960C, #8A6000)",
                backgroundSize: "200% 100%",
                border: "none", borderRadius: 10,
                color: "#0a0a0a", fontWeight: 800, fontSize: 13,
                letterSpacing: "0.14em", cursor: loading ? "not-allowed" : "pointer",
                transition: "opacity 0.2s",
              }}
            >
              {loading ? "SIGNING IN…" : "SIGN IN"}
            </button>
          </form>

          <div style={{ height: 2, background: "linear-gradient(90deg, transparent, rgba(200,150,12,0.3), transparent)", borderRadius: 1, marginTop: 28 }} />
        </div>

        <p className="text-center mt-5" style={{ fontSize: 10, color: "#3a2a00", letterSpacing: "0.08em" }}>
          PROTECTED · MAKALU AGRO AND TRADE
        </p>
      </div>
    </div>
  );
}
